export const INDEX_SEPARATOR = ';'
export const VALUE_SEPARATOR = '|'

export const CLOSE_VIEWPORT_ACTION = "CLOSE_VIEWPORT";

export const DOCUMENT_WIDGET_OPEN_ACTION = "OPEN";
export const DOCUMENT_WIDGET_DOWNLOAD_ACTION = "DOWNLOAD";
export const DOCUMENT_WIDGET_UPLOAD_ACTION = "UPLOAD";
export const DOCUMENT_WIDGET_CHECKOUT_ACTION = "CHECKOUT";
export const DOCUMENT_WIDGET_CHECKIN_ACTION = "CHECKIN";

export const TABLE_WIDGET_SELECT_ACTION = "SELECT";
export const TABLE_WIDGET_OPEN_ACTION = "OPEN";
export const TABLE_WIDGET_NEW_ACTION = "NEW";
export const TABLE_WIDGET_DELETE_ACTION = "DELETE";
export const TABLE_WIDGET_MOVEUP_ACTION = "MOVEUP";
export const TABLE_WIDGET_MOVEDOWN_ACTION = "MOVEDOWN";
export const TABLE_WIDGET_SORT_ACTION = "SORT";
export const TABLE_WIDGET_NEXTPAGE_ACTION = "NEXTPAGE";
export const TABLE_WIDGET_PREVPAGE_ACTION = "PREVPAGE";

export const TOOLBAR_WIDGET_NEW_ACTION = "NEW";
export const TOOLBAR_WIDGET_DELETE_ACTION = "DELETE";
export const TOOLBAR_WIDGET_PREV_ACTION = "PREV";
export const TOOLBAR_WIDGET_NEXT_ACTION = "NEXT";
export const TOOLBAR_WIDGET_SEARCH_ACTION = "SEARCH";
export const TOOLBAR_WIDGET_RELOAD_ACTION = "RELOAD";
export const TOOLBAR_WIDGET_UNDO_ACTION = "UNDO";
export const TOOLBAR_WIDGET_LOCK_ACTION = "LOCK";
export const TOOLBAR_WIDGET_SAVE_ACTION = "SAVE";

export const ITEMLIST_WIDGET_SELECTED_ACTION = "ITEM_SELECTED";
export const ITEMLIST_WIDGET_MOVEITEMUP_ACTION = "MOVE_ITEM_UP";
export const ITEMLIST_WIDGET_MOVEITEMDOWN_ACTION = "MOVE_ITEM_DOWN";
export const ITEMLIST_WIDGET_NEWROOT_ACTION = "NEW_ROOT";
export const ITEMLIST_WIDGET_NEWCHILD_ACTION = "NEW_CHILD";
export const ITEMLIST_WIDGET_NEWSIBLING_ACTION = "NEW_SIBLING";
export const ITEMLIST_WIDGET_CHANGEITEMSTUCTURE_ACTION = "CHANGE_ITEM_STRUCTURE";

export const STRINGLIST_WIDGET_NEW_ITEM_ACTION = "NEW";
export const STRINGLIST_WIDGET_DELETE_ITEM_ACTION = "DELETE";
export const STRINGLIST_WIDGET_MOVEUP_ACTION = "MOVE_ITEM_UP";
export const STRINGLIST_WIDGET_MOVEDOWN_ACTION = "MOVE_ITEM_DOWN";
export const STRINGLIST_WIDGET_SELECT_ITEM_ACTION = "SELECT";

export const EMBEDDEDFORM_WIDGET_COLLAPSE_ACTION = "COLLAPSE";
export const EMBEDDEDFORM_WIDGET_EXPAND_ACTION = "EXPAND";

export const DEFAULT_ROW_HEIGHT = 2.0;
export const DEFAULT_WIDGET_DISTANCE = 0.5;
export const VIEWPORT_FONT_SIZE_IN_PX = 14;